import { RefObject, ReactNode, useRef } from 'react';
import { useRefElement } from '../..';

type RefProviderProps<T extends HTMLElement = HTMLElement> = {
  children: (refs: {
    ref: RefObject<T | null>;
    trackedElement: T | null;
  }) => ReactNode;
};

export function RefProvider<T extends HTMLElement = HTMLElement>({
  children,
}: RefProviderProps<T>) {
  const ref = useRef<T>(null);
  const trackedElement = useRefElement(ref);

  return <>{children({ ref, trackedElement })}</>;
}
